import { Component, computed, input, Signal, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { GeoData } from '../../types/GeoData';
import { HttpClient } from '@angular/common/http';
import { topojson } from 'chartjs-chart-geo';
import { GraphComponent } from '../graph/graph.component';
import { ChartData, ChartOptions } from 'chart.js';
import { interpolateColor } from '../../utils/color/color';
import { LanguageService } from '../../state/language/language.service';
import { getCountryCode } from 'countries-list';

@Component({
  selector: 'app-graph-geo',
  imports: [GraphComponent],
  templateUrl: './graph-geo.component.html',
  styleUrl: './graph-geo.component.css',
})
export class GraphGeoComponent {
  private httpClient = inject(HttpClient);
  private languageService = inject(LanguageService);

  public visitors = input<{ [date: string]: number } | undefined>();
  private world: Signal<GeoData | undefined> = toSignal(
    this.httpClient.get<GeoData>('world-atlas/countries-110m.json'),
  );

  public data: Signal<ChartData | undefined> = computed(() => {
    const displayNames = new Intl.DisplayNames(this.languageService.getCurrentLocale(), { type: 'region' });
    const world = this.world();
    const visitors = this.visitors();
    if (!world || !visitors) return;
    const countries = topojson.feature(world, world.objects.countries).features;
    const land = topojson.feature(world, world.objects.land).features;

    return {
      labels: countries.map((country) => {
        const code = getCountryCode(country.properties.name);
        return code ? (displayNames.of(code) ?? country.properties.name) : country.properties.name;
      }),
      datasets: [
        {
          label: $localize`Countries`,
          outline: land,
          data: countries.map((d) => ({
            feature: d,
            value: visitors[d.properties.name] || 0,
          })),
        },
      ],
    };
  });
  public options: ChartOptions = {
    maintainAspectRatio: false,
    scales: {
      projection: { axis: 'x', projection: 'naturalEarth1' },
      color: {
        axis: 'x',
        quantize: 25,
        interpolate: (v) => interpolateColor('#ffffff', '#004e6e', v),
        legend: {
          position: 'left',
          length: 380,
          margin: { left: 20 },
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };
}
